//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'Weir',
  data () {
    return {
      defaultJson: {
        "Oxygen consumption": "耗氧量（VO₂）",
        "Carbon dioxide production": "二氧化碳生产量（VCO₂）"
      },
      form: {
        vo2:'',
        vco2:'',
      },
      hasScore: false,
      disabled: false,
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true

      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      console.log(form)
      if (!flag) {
        self.hasScore = false
        return '...'
      } else {
        // REE（kcal/d）=1.44*[3.941*VO2（ml/min）＋1.11*VCO2（ml/min）]
        let result = 1.44 * (3.941 * form.vo2 + 1.11 * form.vco2)
        self.hasScore = true
        return String(result.toFixed(2))
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Trauma/Weir.vue